import { FaLinkedin, FaBars } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import { useState, useEffect } from 'react';

const Navbar = ({ aboutRef, expRef, projectsRef }) => {
  const [selection, setSelection] = useState('');
  const [showBackground, setShowBackground] = useState(false);
  const [showNavbar, setShowNavbar] = useState(false);

  const scrollTo = (ref, type) => {
    setSelection(type);
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        setShowBackground(true);
      } else {
        setShowBackground(false);
      }
    });
  }, []);

  useEffect(() => {
    var timeout;
    if (selection !== '') {
      timeout = setTimeout(() => {
        setSelection('');
      }, 500);
    }

    return () => {
      clearTimeout(timeout);
    };
  });

  return (
    <nav>
      <div
        className={`${
          showBackground || showNavbar
            ? 'showBackground nav-center'
            : 'nav-center'
        }`}
      >
        <div className='nav-header'>
          <h4 style={{ marginTop: '.75rem' }}>Software Engineer</h4>
          <button
            className='nav-toggle'
            type='button'
            title='toggle nav menu'
            onClick={() => setShowNavbar(!showNavbar)}
          >
            <FaBars />
          </button>
        </div>
        <div
          className={`${
            showNavbar ? 'links-container show-container' : 'links-container'
          }`}
        >
          <ul className='links'>
            <li>
              <button
                className={`${selection === 'about' ? 'active' : ''}`}
                title='About'
                type='button'
                onClick={() => scrollTo(aboutRef, 'about')}
              >
                About
              </button>
            </li>
            <li>
              <button
                className={`${selection === 'experience' ? 'active' : ''}`}
                title='Experience'
                type='button'
                onClick={() => scrollTo(expRef, 'experience')}
              >
                Experience
              </button>
            </li>
            <li>
              <button
                className={`${selection === 'projects' ? 'active' : ''}`}
                title='Projects'
                type='button'
                onClick={() => scrollTo(projectsRef, 'projects')}
              >
                Projects
              </button>
            </li>
            <li className='center'>
              <a
                title='open email'
                href='mailto:ray.flores@hotmail.com'
                target={'_blank'}
                rel='noreferrer'
              >
                <FiMail />
              </a>
            </li>
            <li className='center'>
              <a
                title='go to linkedin profile'
                href='https://www.linkedin.com/in/flores-ray/'
                target={'_blank'}
                rel='noreferrer'
              >
                <FaLinkedin />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
